import apiMiddleware from "../api/apiMiddleware";

export const listTransactions = async (page = 1, search = "", filters = {}) => {
  const params = new URLSearchParams();
  params.append("page", String(page));
  params.append("per_page", String(filters.per_page || 10));

  if (search) params.append("search", search);
  if (filters.status) params.append("status", filters.status);
  if (filters.service_type) params.append("service_type", filters.service_type);

  const response = await apiMiddleware.get(`/transactions?${params.toString()}`);
  const pagination = response.data?.data || {};

  return {
    data: pagination.data || [],
    current_page: pagination.current_page || 1,
    last_page: pagination.last_page || 1,
    total: pagination.total || 0,
    per_page: pagination.per_page || 10,
  };
};

